export const styles = `
<style>
	:host {
		display: block;
		--inline-padding: 12px;
	}
	
	@media only screen and (min-width: 601px) {
		:host {
			--inline-padding: 24px;
			width: var(--wdk-dialog-width-desktop);
		}
	}
	
	.dialogContent {
		display: flex;
		flex-flow: column;
		max-height: 80dvh;
		width: 100%;
		text-align: center;
		color: var(--COLOR_support_white_default);
	}
	
	@media only screen and (max-width: 600px) {
		:host([mobile-full-height]) .dialogContent {
			height: 100dvh;
			max-height: 100dvh;
		}
	}
	
	.dialogContent > header h2 {
		display: flex;
		align-items: center;
		min-height: 60px;
		margin: 0;
		padding: 18px var(--inline-padding) var(--inline-padding) var(--inline-padding);
		font: var(--FONT_default_200);
	}
	
	:host([closing-x="inside"]) .dialogContent > header h2 {
		padding: 18px 68px var(--inline-padding) var(--inline-padding);
	}
	
	.dialogContent > article {
		display: flex;
		flex-direction: column;
		padding: 0 var(--inline-padding) var(--inline-padding) var(--inline-padding);
		overflow-y: auto;
		scrollbar-color: var(--COLOR_gray_400) var(--COLOR_support_white_default);
		scrollbar-width: thin;
		flex-grow: 1;
	}
	
	.dialogContent:has(footer) > article {
		padding: 0 var(--inline-padding);
	}
	
	/* Safari doesn't support the above and needs this webkit selectors */
	.dialogContent > article::-webkit-scrollbar {
		width: 12px;
		height: 12px;
	}
	
	.dialogContent > article::-webkit-scrollbar-track {
		background: transparent;
		border-radius: var(--RADIUS_rounded);
	}
	
	.dialogContent > article::-webkit-scrollbar-thumb {
		background: var(--COLOR_gray_400);
		border: 3px solid transparent;
		border-radius: var(--RADIUS_rounded);
		background-clip: content-box;
	}
	
	.dialogContent > article::-webkit-scrollbar-thumb:hover {
		background: var(--COLOR_gray_300);
		border: 3px solid red;
		background-clip: content-box;
	}
	
	.dialogContent > footer {
		padding: 24px var(--inline-padding);
	}
	
	.dialogContent > footer ul {
		width: 100%;
		display: flex;
		flex-flow: wrap;
		gap: 20px;
		justify-content: space-between;
		margin: 0;
		padding: 0;
	}
	
	.dialogContent > footer ul li {
		flex-basis: calc(40% - 20px);
		flex-grow: 1;
		list-style: none;
		text-align: center;
		vertical-align: top;
		margin: 0;
		padding: 0;
	}
	
	/* Full width for Buttons if shown in 2 lines */
	.dialogContent > footer:has(li:nth-child(2)) ::slotted([slot^='button_']) {
		width: 100%;
	}
	
	.dialogContent > footer small {
		display: block;
    	font: var(--FONT_default_50);
    	margin-top: 32px;
	}
</style>
`;
